import React, { useEffect } from "react";
import Hero from "../components/Hero";
import Newsletter from "../components/Newsletter";
import Portfolio from "../components/Portfolio";
import Products from "../components/Products";
import Services from "../components/Services";
import scrollreveal from "scrollreveal";

export default function Home() {
  useEffect(() => {
    const sr = scrollreveal({
      origin: "top",
      distance: "80px",
      duration: 2000,
      reset: false,
    });
    sr.reveal(
      `
        nav,
        #home,
        #services,
        #portfolio,
        #testimonials,
        #products,
        #newsletter,
        .footer
    `,
      {
        opacity: 0,
        interval: 200,
      }
    );
  }, []);
  return (
    <>
      <Hero />
      <Services />
      <Portfolio />
      <Products />
    </>
  );
}
